import { ArrowRight, LockIcon } from 'lucide-react'
import type { ComponentType } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/tailwind.utils'
import { Badge } from '@/components/ui/badge'

interface ModuleOverviewItemProps {
  title: string
  description: string
  actionLabel: string
  Icon: ComponentType<{ className?: string; active?: boolean }>
  className?: string
  onAction?: () => void
  enhanced?: boolean
}

const ModuleOverviewItem = ({
  title,
  description,
  actionLabel,
  Icon,
  className,
  onAction,
  enhanced,
}: ModuleOverviewItemProps) => (
  <div
    className={cn(
      'flex gap-0 bg-card hover:bg-neutral border dark:hover:border-neutral-100  p-2  rounded-lg',
      className,
    )}
  >
    {Icon ? <Icon active className="-mt-3 h-16 w-16 shrink-0 text-primary" /> : null}
    <div className="flex flex-1 flex-col gap-2">
      <div className="flex gap-2 justify-start">
        <h3 className="text-base font-bold text-foreground ">{title}</h3>
        {enhanced ? (
          <Badge
            size={'xs'}
            variant="secondary"
            className=" text-xs font-semibold uppercase tracking-wide bg-neutral-300 dark:text-foreground dark:bg-darkBlue text-rexBlue-900"
          >
            <LockIcon className="h-3 w-3 mr-1" /> Enhanced subscription
          </Badge>
        ) : (
          <div></div>
        )}
      </div>

      <p className="line-clamp-3 min-h-[4.875rem] max-w-3xl text-sm leading-relaxed text-foreground">
        {description}
      </p>

      <div className="flex justify-end">
        <Button variant="ghost" className="text-base" onClick={onAction}>
          {actionLabel}
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  </div>
)

export default ModuleOverviewItem
